(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq-accordion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const faqItems = document.querySelectorAll('.custom-faq-accordion__item');
  
  faqItems.forEach(item => {
    const header = item.querySelector('.custom-faq-accordion__header');
    
    header.addEventListener('click', () => {
      const isActive = item.classList.contains('active');
      
      // Close all items
      faqItems.forEach(otherItem => {
        otherItem.classList.remove('active');
        otherItem.querySelector('.custom-faq-accordion__content').style.maxHeight = null;
      });
      
      // If this item wasn't active, open it
      if (!isActive) {
        item.classList.add('active');
        const content = item.querySelector('.custom-faq-accordion__content');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
  
  // Open first item by default
  if (faqItems.length > 0) {
    faqItems[0].classList.add('active');
    const firstContent = faqItems[0].querySelector('.custom-faq-accordion__content');
    firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', (event) => {
const details = document.querySelectorAll('details');
details.forEach((detail) => {
detail.addEventListener('toggle', (event) => {
if (detail.open) {
const icon = detail.querySelector('svg');
icon.style.transform = 'rotate(180deg)';
} else {
const icon = detail.querySelector('svg');
icon.style.transform = 'rotate(0deg)';
}
});
});
});

  } catch(e) { console.error(e); }
})();
})();
